import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@services/authentication';
import { APP_ROUTES } from 'app/constants';
import { map, take } from 'rxjs';

export const authenticationGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const authenticationService = inject(AuthenticationService);

    // Wait for cross-tab sync to complete before checking authentication
    return authenticationService.syncReady$.pipe(
        take(1),
        map(() => {
            if (!authenticationService.isAuthenticated()) {
                authenticationService.logout();

                const returnUrl = state.url;
                void router.navigate([APP_ROUTES.Login], {
                    queryParams: { returnUrl }
                });
                return false;
            }

            return true;
        })
    );
};
